// @core/api/endpoints/attachment/confirm_upload.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AttachmentResponse,
  ConfirmUploadRequest,
} from '../../../types/attachment';

const BASE_PATH = '/attachment';

/**
 * Confirm upload and trigger processing
 * Confirms that a file upload has completed successfully and triggers async processing. Processing includes thumbnail generation, metadata extraction, and transcoding based on file type.
 */
export async function ConfirmUpload(
  data: ConfirmUploadRequest,
  options?: RequestOptions
): Promise<AttachmentResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/attachments/confirm-upload`;
  const requestOptions = options;
  return client.post<AttachmentResponse>(requestPath, data, requestOptions);
}
